/***************************************************************************/
"use client";
/***************************************************************************/

import * as ToastPrimitives from "@radix-ui/react-toast";
import { cva } from "class-variance-authority";
import * as React from "react";
import { cn } from "../../../utils/css";
import { ToastContext } from "./toast";

const toastTitleVariants = cva("", {
  variants: {
    variant: {
      default: "text-foreground",
      success: "text-success",
      info: "text-info",
      warning: "text-warning",
      error: "text-error",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

const ToastTitle = React.forwardRef<
  React.ElementRef<typeof ToastPrimitives.Title>,
  React.ComponentPropsWithoutRef<typeof ToastPrimitives.Title>
>(({ className, ...props }, ref) => {
  const { variant } = React.useContext(ToastContext);

  return (
    <ToastPrimitives.Title
      ref={ref}
      className={cn(
        "m-0 font-medium [&_.lucide]:h-4 [&_.lucide]:w-4 [&_.lucide]:mt-[4px]",
        toastTitleVariants({ variant }),
        className,
      )}
      {...props}
    />
  );
});
ToastTitle.displayName = ToastPrimitives.Title.displayName;

export { ToastTitle, toastTitleVariants };
